import colors from '@packages/core/styles/colors';
import { Typography } from '@packages/ui/shared';
import { Link } from 'react-router-dom';
import React, { FC } from 'react';
import { createUseStyles } from 'react-jss';
import { PublicationType } from '@web/vin-sessions/components/stis-publications/publication-type-icons';
import { StisDocument } from '@web/vin-sessions/types';
import { openDocumentTab, resolveDocumentUrl } from '@web/vin-sessions/utils/open-document-tab';
import { useAuthState } from '@packages/contexts/auth';

const useStyles = createUseStyles({
    tableContainer: {
        marginBottom: 24,
        width: '35%',
    },
    menuTable: {
        minHeight: 280,
        width: '32%',
        color: '#f9f9f9',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        overflow: 'hidden',
    },
    headerContainer: {
        width: '100%',
        padding: 15,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: colors.grayOne,
    },
    link: {
        fontSize: 15,
        fontWeight: '400',
        color: '#007BFF',
        cursor: 'pointer',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    content: {
        borderTop: '1px solid #ddd',
    },
    noData: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
    },
    noDataContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 5,
        textAlign: 'center',
    },
});

interface MenuTableProps {
    tableData: StisDocument[];
    header: string;
    noDataText: string;
    noDataSubText: string;
    navLink: string;
    blockedOverlay?: React.ReactNode;
}

export const MenuTable: FC<MenuTableProps> = (props) => {
    const { tableData, header, noDataText, noDataSubText, navLink, blockedOverlay } = props;
    const classes = useStyles();
    const { account, token } = useAuthState();

    return (
        <div className={`my-4 border rounded ${classes.menuTable}`}>
            <div className={classes.headerContainer}>
                <Typography variant="label" numberOfLines={1}>
                    {header}
                </Typography>
                <Link to={navLink} className={classes.link}>
                    See all
                </Link>
            </div>

            {blockedOverlay}

            <div className={tableData.length == 0 ? classes.noData : ''}>
                {tableData.length > 0 &&
                    tableData.map((item, index) => (
                        <div key={index} className={classes.content}>
                            <div style={{ display: 'flex', padding: 15, gap: 24 }}>
                                <div style={{ maxWidth: '20%' }}>
                                    <PublicationType publicationType={item.docType} size={24} />
                                </div>
                                {item && item.title && (
                                    <div
                                        className={classes.link}
                                        style={{ marginTop: 3 }}
                                        onClick={async () => {
                                            await openDocumentTab(() => resolveDocumentUrl(item, account, token));
                                        }}
                                    >
                                        {item.title}
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}

                {tableData.length == 0 && (
                    <div className={classes.noDataContainer}>
                        <Typography style={{ fontSize: 15, fontWeight: 'bold', color: colors.graySix }}>
                            {noDataText}
                        </Typography>
                        <Typography style={{ fontSize: 12, fontWeight: '200', color: colors.graySix }}>
                            {noDataSubText}
                        </Typography>
                    </div>
                )}
            </div>
        </div>
    );
};
